import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { StatusConfiguration } from "@nms-angular-toolkit/nms-status";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";
import { HardwareTypeOnu, StatusDetails, OltStatusInfo } from "@nms-ng2/app/modules/device/gpon-onus/gpon-onus.models";
import { CutStringPipe } from "@nms-ng2/app/shared/pipes/cut-string.pipe";
import {
    ANGULARJS_TRANSLATE,
    CPU_USAGE,
    DEVICE_AUGMENT_SERVICE,
    DEVICE_SERVICE,
    MANAGEMENT_DEVICE_REST_SERVICE,
    MEMORY_USAGE
} from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";

/**
 * Exibe informações básicas do equipamento, no contexto de um equipamento.
 */
@Component({
    selector: "device-briefing",
    templateUrl: "./device-briefing.component.html",
    styleUrls: ["./device-briefing.component.scss"]
})
export class DeviceBriefingComponent implements OnChanges {

    readonly GREEN = "#5cb85c";
    readonly YELLOW = "#f0ad4e";
    readonly RED = "#b12525";

    colorProgressBar: string;
    bgProgressBar: string;
    modelDevice: string;
    deviceImagePath: object;
    statusConfiguration: StatusConfiguration;
    hardwareTypeOnu: typeof HardwareTypeOnu;
    isPtBrLang: boolean;

    @Input()
    deviceBriefing: Device;

    constructor(@Inject(ANGULARJS_TRANSLATE) private readonly translate: any,
                @Inject(DEVICE_SERVICE) private readonly deviceService: any,
                @Inject(DEVICE_AUGMENT_SERVICE) private readonly deviceAugmentService: any,
                @Inject(MANAGEMENT_DEVICE_REST_SERVICE) private readonly managedeviceRestService: any,
                @Inject(CPU_USAGE) private readonly cpuUsage: any,
                @Inject(MEMORY_USAGE) private readonly memoryUsage: any,
                private readonly cutStringPipe: CutStringPipe) {
        this.isPtBrLang = this.translate.preferredLanguage() === "pt_BR";
    }

    load() {
        this.managedeviceRestService.findDeviceById(this.deviceBriefing.id).then((data) => {
            const deviceBriefing = this.deviceAugmentService.resolveDevice(data);
            this.deviceBriefing = { ... deviceBriefing };
            this.processDeviceBriefing();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.hardwareTypeOnu = HardwareTypeOnu;
        if (changes.deviceBriefing) {
            this.processDeviceBriefing();
        }
    }

    fillBgColorProgressBar(usageType: HardwareTypeOnu, usage: string) {
        this.calculateProgressBarStatusColor(Number(usage), this.thresholdsType(usageType));

        return {
          "background-color": this.bgProgressBar
        };
    }

    fillProgressBar(usageType: HardwareTypeOnu, usage: string) {
        this.calculateProgressBarStatusColor(Number(usage), this.thresholdsType(usageType));

        return {
          width: `${usage}%`,
          "background-color": this.colorProgressBar
        };
    }

    private processDeviceBriefing() {
        this.modelDevice = this.cutStringPipe.transform(this.deviceBriefing.model, 30);
        const statusFeature: StatusDetails = OltStatusInfo[this.deviceBriefing.status];

        this.deviceService.getDeviceImageByModel(this.deviceBriefing.model).then(image => {
            this.deviceImagePath = {
                "background-image": `url("data:image/svg+xml;utf8,${encodeURIComponent(image)}")`
            };
        });

        this.statusConfiguration = {
            label: this.translate.instant(statusFeature.label),
            bgColor: statusFeature.color,
            color: "#000"
        }
    }

    private thresholdsType(usageType: HardwareTypeOnu): { low: number, high: number } {
        const hardwareType = {
            [HardwareTypeOnu.CPU]: { low: this.cpuUsage.LOW, high: this.cpuUsage.HIGH },
            [HardwareTypeOnu.MEMORY]: { low: this.memoryUsage.LOW, high: this.memoryUsage.HIGH }
        };

        return hardwareType[usageType];
    }

    private calculateProgressBarStatusColor(usage: number, thresholds: { low: number, high: number }) {
        if (usage < thresholds.low) {
            this.colorProgressBar = this.GREEN;
            this.bgProgressBar = this.getColorWithAlpha(this.GREEN, 0.15);
        } else if (usage >= thresholds.low && usage < thresholds.high) {
            this.colorProgressBar = this.YELLOW;
            this.bgProgressBar = this.getColorWithAlpha(this.YELLOW, 0.15);
        } else {
            this.colorProgressBar = this.RED;
            this.bgProgressBar = this.getColorWithAlpha(this.RED, 0.15);
        }
    }

    private getColorWithAlpha(colorHex: string, opacity: number) {
        const opacityInHex = Math.floor(opacity * 255).toString(16).padStart(2, "0");

        return `${colorHex}${opacityInHex}`;
    }

}
